"use client";
import { useEffect } from "react";
import useModal from "../lib/features/modal/modal.hook";
import useAuth from "../lib/features/auth/auth.hook";
import useMobile from "../lib/features/mobile/mobile.hook";

const GENDER_STORAGE_KEY = "gender-modal-shown";

export const useGenderSelection = () => {
  const { createModal } = useModal();
  const { isAuthenticated, userProfile } = useAuth();
  const { isPurePage } = useMobile();

  useEffect(() => {
    if (isPurePage) return;
    if (!isAuthenticated || !userProfile) return;

    const alreadyShown = localStorage.getItem(GENDER_STORAGE_KEY);
    if (alreadyShown) return;

    const needsGenderSelection =
      !userProfile.gender || userProfile.gender === "unknown";

    if (!needsGenderSelection) return;

    const timer = setTimeout(() => {
      createModal("gender-selection");
    }, 1500);

    return () => clearTimeout(timer);
  }, [isPurePage, isAuthenticated, userProfile, createModal]);
};
